import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AccordionComponent } from '@domgen/dgx-fe-components/accordion';
import { RichTextComponent } from '@domgen/dgx-fe-components/content';
import { IconComponent } from '@domgen/dgx-fe-components/icon';
import { ProtectionBenefitsAccordionPanel } from '@us-registration/util-models';

@Component({
  selector: 'us-registration-protection-details-accordion-panel-wib',
  templateUrl: './protection-details-accordion-panel-wib.component.html',
  styleUrls: ['./protection-details-accordion-panel-wib.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AccordionComponent, IconComponent, NgClass, RichTextComponent],
})
export class ProtectionDetailsAccordionPanelWibComponent {
  @Input() isDesktop?: boolean;
  @Input() panels: ProtectionBenefitsAccordionPanel[] = [];
}
